import { BMCard, BMText, useBMTheme } from "@traveloka/district-bloom";
import IcSystemToolRecentSearch from "@traveloka/icon-kit-web/react/IcSystemToolRecentSearch";
import { Pressable, StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import {
  PreviousHotelSearchData,
  SelectedPreviousHotelSearchData,
} from "../HotelSearchForm";

type Props = {
  searchItem: PreviousHotelSearchData;
  selectPreviousSearchData: (
    searchData: SelectedPreviousHotelSearchData
  ) => void;
  testID?: string;
};

export default function PreviousSearchItem(props: Props) {
  const { searchItem, selectPreviousSearchData, testID } = props;
  const bmTheme = useBMTheme();

  if (searchItem)
    return (
      <BMCard
        testID={testID}
        style={styles.container}
        layout="COMPACT"
        elevation="BOX"
      >
        <Pressable
          onPress={() =>
            selectPreviousSearchData({
              ...searchItem,
              checkInDate: new Date(searchItem.checkInDate),
              checkOutDate: new Date(searchItem.checkOutDate),
            })
          }
        >
          <BMView row align="start" spacing="sm">
            <BMView style={styles.searchIcon}>
              <IcSystemToolRecentSearch
                color={bmTheme.BMComponents.BMStyleTextInkSecondary}
                accentColor={bmTheme.BMComponents.BMStyleTextInkSecondary}
                width={22}
                height={22}
              />
            </BMView>
            <BMText
              ellipsizeMode="tail"
              numberOfLines={2}
              ink="BMStyleTextInkPrimary"
              variant="uiLarge"
            >
              {searchItem.geoName}
            </BMText>
          </BMView>
          <BMText
            style={styles.date}
            variant="uiNormalLi"
            ink="BMStyleTextInkSecondary"
          >
            {`${searchItem.checkInDate} - ${searchItem.checkOutDate}`}
          </BMText>
        </Pressable>
      </BMCard>
    );
}

const styles = StyleSheet.create({
  container: {
    width: 185,
  },
  searchIcon: {
    flexShrink: 0,
  },
  date: {
    marginTop: "auto",
  },
});
